<template>
  <img src="~BRAND/assets/logo-menu.svg"/>
</template>

<script>
export default {};
</script>



// WEBPACK FOOTER //
// src/components/shared/logos/LogoMenu.vue